'use client';

import AppShell from '@umodeapporg/ui/components/Shell/AppShell';
import ShellLanguageToggle from '@umodeapporg/ui/components/Shell/LanguageToggle';
import { type ISidebarMenuItem } from '@umodeapporg/ui/components/Shell/SidebarMenu';
import ShellThemeToggle from '@umodeapporg/ui/components/Shell/ThemeToggle';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@/components/theme/ThemeProvider';
import { useLanguage } from '@/domain/common/hooks/useLanguage';
import { logout } from '@/infrastructure/http/authRefresh';

import { UserMenu } from './UserMenu';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const { t } = useTranslation('common');
  const { preference, setPreference } = useTheme();
  const { currentLanguage, changeLanguage } = useLanguage();

  const items = useMemo<Array<ISidebarMenuItem>>(
    () => [
      { icon: 'storefront', text: t('nav.crm'), to: '/', end: true },
      { icon: 'list', text: t('nav.examples'), to: '/examples' },
    ],
    [t],
  );

  return (
    <AppShell
      items={items}
      homePath="/"
      controlsSlot={
        <>
          <ShellThemeToggle preference={preference} onChange={setPreference} />
          <ShellLanguageToggle language={currentLanguage} onChange={changeLanguage} />
        </>
      }
      userMenuSlot={<UserMenu />}
      onLogout={logout}
    >
      {children}
    </AppShell>
  );
}
